import { useState, useEffect } from 'react';

import { useJanitor } from './useJanitor';
import ABTest from '../modules/abTest';

type AssignFunction = () => boolean;
type AssignValue = boolean | AssignFunction;
export type ABTestOptions = AssignValue | {
  assign?: AssignValue;
  storage?: 'local' | 'global';
};

/**
 * DEPRECATED -- USE useAndAssignTest
 * DEPRECATED -- Hook which returns a value indicating whether or not someone is in a feature test
 * DEPRECATED -- @param flagName The flag to check
 * DEPRECATED -- @param flagPercent The probability of being assigned to the test group
 * DEPRECATED -- @param flagOptions Used to specify conditions under which to assign to
 * group / where to storethis
 */
export const useInFeatureTest = (
  flagName: string,
  flagPercent: number,
  flagOptions: ABTestOptions = true,
): boolean => {
  const janitor = useJanitor();
  const [inFeatureTest, setInFeatureTest] = useState<boolean>(false);

  useEffect(() => {
    janitor.addPromise(
      ABTest.isInFeatureTest(
        flagName,
        flagPercent,
        typeof flagOptions === 'object' ? flagOptions : { assign: flagOptions },
      ),
    ).then(setInFeatureTest);
  }, [flagName, flagPercent, flagOptions]);

  return inFeatureTest;
};

export default useInFeatureTest;
